// extracted by mini-css-extract-plugin
export default {"pillTab":"style_pillTab__AkVoP","pill":"style_pill__WkrfO","pagination__input__withPadding":"style_pagination__input__withPadding__iwfWG"};